import React, { useEffect, useState } from 'react';
import { TrendingUp, FileText, BarChart3, PieChart } from 'lucide-react';

const CursorTrail = () => {
  const [trails, setTrails] = useState([]);

  const icons = [TrendingUp, FileText, BarChart3, PieChart];

  useEffect(() => {
    let lastTime = 0;
    const handleMouseMove = (e) => {
      const now = Date.now();
      // Criar trail a cada 100ms
      if (now - lastTime > 100) {
        lastTime = now;
        
        const RandomIcon = icons[Math.floor(Math.random() * icons.length)];
        const newTrail = {
          id: now,
          x: e.clientX,
          y: e.clientY,
          Icon: RandomIcon
        };

        setTrails(prev => [...prev, newTrail].slice(-15)); // Manter apenas os últimos 15

        // Remover após 800ms
        setTimeout(() => {
          setTrails(prev => prev.filter(trail => trail.id !== newTrail.id));
        }, 800);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="cursor-trail-container" style={{ pointerEvents: 'none', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999 }}>
      {trails.map((trail) => {
        const Icon = trail.Icon;
        return (
          <div
            key={trail.id}
            className="cursor-trail-icon"
            style={{
              position: 'absolute',
              left: trail.x - 10,
              top: trail.y - 10,
              animation: 'trailFade 0.8s ease-out forwards'
            }}
          >
            <Icon className="h-5 w-5" style={{ color: '#45C1E0' }} />
          </div>
        );
      })}
    </div>
  );
};

export default CursorTrail;
